var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.319 3.17689C17.0024 2.49347 18.1104 2.49347 18.7938 3.17689L23.0365 7.41953C23.7199 8.10295 23.7199 9.21099 23.0365 9.8944L11.7228 21.2081C11.6023 21.3285 11.4445 21.4044 11.2753 21.4232L4.9113 22.1303C4.68485 22.1555 4.45925 22.0763 4.29814 21.9152C4.13704 21.7541 4.0579 21.5285 4.08306 21.3021L4.79017 14.9381C4.80898 14.7688 4.88483 14.611 5.00525 14.4906L16.319 3.17689ZM17.7332 4.23755C17.6355 4.13992 17.4773 4.13992 17.3796 4.23755L6.25194 15.3652L5.67742 20.5359L10.8481 19.9614L21.9758 8.83374C22.0734 8.73611 22.0734 8.57782 21.9758 8.48019L17.7332 4.23755Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6725 10.6014L9.24786 18.0261L8.1872 16.9654L15.6118 9.54077L16.6725 10.6014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8545 12.0156L14.1976 6.35876L15.2583 5.2981L20.9152 10.9549L19.8545 12.0156Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1a5ce62bad3b2e7caea230606d2ea66c.svg";
export { ForwardRef as ReactComponent };